import { render } from "./PlansBotRive.vue?vue&type=template&id=e4611f6c&scoped=true"
import script from "./PlansBotRive.vue?vue&type=script&lang=js"
export * from "./PlansBotRive.vue?vue&type=script&lang=js"

import "./PlansBotRive.vue?vue&type=style&index=0&id=e4611f6c&lang=scss&scoped=true"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4611f6c"]])

export default __exports__